import React, { useState, useEffect, useMemo } from "react";
import { MdDeleteOutline } from "react-icons/md";
import { Eye } from "lucide-react";
import { TbEdit,TbEye } from "react-icons/tb";
import AddUser from "./Assets/AddUser";
import EditUser from "./Assets/EditUser";
import DeleteUser from "./Assets/DeleteModal";
import ViewUser from "./Assets/UserModel";
import { toast } from "react-toastify";

const UserDetails = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [deleteModalShow, setDeleteModalShow] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [addUserModel, setAddUserModel] = useState(false);
  const [editUserModel, setEditUserModel] = useState(false);
  const [itemToEdit, setItemToEdit] = useState(null);
  const [viewUserModel, setViewUserModel] = useState(false);
  const [itemToView, setItemToView] = useState(null);

  const itemsPerPage = 20;

  const Auth = localStorage.getItem("authToken");

  useEffect(() => {
    fetchUsers();
  }, []);
  // fetch the all data
  const fetchUsers = async () => {
    try {
      const response = await fetch("https://support.ace-school-backend.serverscripts.in/api/v1/admin/staff/view", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${Auth}`
        },
      });

      if (!response.ok) throw new Error("Failed to fetch users");
      const result = await response.json();
      setUsers(result.data || []);
      setLoading(false);
    } catch (err) {
      //console.error("Something went wrong");
      setError(err.message);
      setLoading(false);
    }
  };

  
  const filteredUsers = useMemo(() => {
    const today = new Date();
    let filtered = users.filter((u) => {
      const nameMatch = u.name?.toLowerCase().includes(search.toLowerCase());

      
      
      

      return nameMatch ;
    });

    
    

    return filtered;
  }, [users, search]);

  // Pagination Method
  const totalPages = Math.ceil(filteredUsers.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentUsers = filteredUsers.slice(startIndex, startIndex + itemsPerPage);

  const handlePageChange = (page) => {
    if (page > 0 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  if (loading) return <p>Loading...</p>;
  if (error) return <p className="text-red-500">{error}</p>;

  const handleAddUserClick = () => {
    setAddUserModel(true);
  };

  const cancelAddUser = () => {
    setAddUserModel(false);
  };
  
    const confirmAddUser = async (formData) => {
    try {
      
      const response = await fetch("https://support.ace-school-backend.serverscripts.in/api/v1/admin/staff/add", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${Auth}`
        },
        body: JSON.stringify(formData),  
      });

      const errorText = await response.json();
      if (!errorText.success) {
        
        toast.error(errorText.message || "User Added Successfully");
        throw new Error(`Failed to save user: ${errorText}`);
        
      }else{
        toast.success(errorText.message || "User Added Successfully");
      }
    } catch (error) {
      //console.error("Something went wrong");
    }
    fetchUsers();
    setAddUserModel(false);
  };

  const handleEditUserClick = (user) => {
    setItemToEdit(user);
    setEditUserModel(true);
  };

  const cancelEditUser = () => {
    setEditUserModel(false);
    setItemToEdit(null);
  };

  const confirmEditUser = async (formData) => {
    try {

      const response = await fetch(`https://support.ace-school-backend.serverscripts.in/api/v1/admin/staff/edit/${formData.id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${Auth}`,
        },
        body: JSON.stringify(formData), 
      });

      const errorText = await response.json();
      if (!errorText.success) {
        
        toast.error(errorText.message || "User Updated Successfully");
        throw new Error(`Failed to save user: ${errorText}`);
      }else{
        toast.success(errorText.message || "User Updated Successfully");
      }
    } catch (error) {
      //console.error("Something went wrong");
    }
    fetchUsers();
    setEditUserModel(false);
    setItemToEdit(null);
  };

  const handleDeleteClick = (id) => {
    setItemToDelete(id);
    setDeleteModalShow(true);
  };

  const confirmDelete = async () => {
    try {


      const response = await fetch(`https://support.ace-school-backend.serverscripts.in/api/v1/admin/staff/delete/${itemToDelete}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${Auth}`
        }  
      });

      const errorText = await response.json();
      if (!errorText.success) {

        toast.error(`${errorText.message} (Tasks: ${errorText.task_count}, Logs: ${errorText.log_count})` || "Failed to delete user");
        throw new Error(`Failed to delete user: ${errorText}`);
      }else{
        toast.success(errorText.message || "User deleted successfully");
      }
    } catch (error) {
      //console.error("Something went wrong");
    }
    fetchUsers();
    setDeleteModalShow(false);
    setItemToDelete(null);
  };

  const cancelDelete = () => {
    setDeleteModalShow(false);
    setItemToDelete(null);
  };

    const handleViewClick = (id) => {
      setItemToView(id);
      setViewUserModel(true);
    };



        const cancelView = () => {
      setViewUserModel(false);
      setItemToView(null);
    };

  return (
    <div className="Task-Details-Container">
      <h2 className="text-xl font-semibold mb-4">Staff List</h2>
      <div className="flex justify-between items-center mb-4">
      <div className="user-heading">
        <button className="text-sm font-normal bg-blue-500 p-2 rounded text-white cursor-pointer" onClick={() => handleAddUserClick()}>Add New Staff</button>
      </div>
      
      <div className="flex justify-end flex-wrap gap-4 mb-4">
        <input
          type="text"
          placeholder="Search by user name..."
          value={search}
          onChange={(e) => {
            setSearch(e.target.value);
            setCurrentPage(1);
          }}
          className="px-4 py-2 border rounded"
        />
        

        
      </div>
      </div>

      
      <table className="w-full text-sm border user-table">
        <thead className="bg-gray-100">
          <tr>
            <th className="px-4 py-2 text-left">#</th>
            <th className="px-4 py-2 text-left">Name</th>
            <th className="px-4 py-2 text-left">Email</th>
            <th className="px-4 py-2 text-left">Designation</th>
            <th className="px-4 py-2 text-left">School Count</th>
            <th className="px-4 py-2 text-left">Action</th>
          </tr>
        </thead>
        <tbody>
          {currentUsers.length > 0 ? (
            currentUsers.map((u, index) => (
              <tr key={u.id || index} className="border-t">
                <td className="px-4 py-2">{startIndex + index + 1}</td>
                <td className="px-4 py-2"><div className="flex items-center space-x-2">{u.name || "N/A"}</div></td>
                <td className="px-4 py-2">{u.email || "N/A"}</td>
                <td className="px-4 py-2">{u.role_name || "N/A"}</td>
                <td className="px-4 py-2">{u.schoolCount || "N/A"}</td>
                <td className="px-4 py-2 flex gap-2">
                  <button className="text-blue-500 hover:text-blue-700" onClick={() => handleViewClick(u.id)}>
                    <TbEye size={22}  />
                  </button>
                  <button className="text-blue-500 hover:text-blue-700" onClick={() => handleEditUserClick(u)}>
                    <TbEdit size={22} />
                  </button>
                  <button className="text-red-500 hover:text-red-700" onClick={() => handleDeleteClick(u.id)}>
                    <MdDeleteOutline size={22} />
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="6" className="text-center py-4 text-gray-500">
                No users found
              </td>
            </tr>
          )}
        </tbody>
      </table>

      
      <div className="flex justify-center mt-4 gap-2 items-center">
        <button
          onClick={() => handlePageChange(currentPage - 1)}
          className="px-3 py-1 border rounded disabled:opacity-50"
          disabled={currentPage === 1}
        >
          Prev
        </button>

        <span className="ml-4 text-sm text-gray-600">
          Page {currentPage} / {totalPages || 1}
        </span>

        <button
          onClick={() => handlePageChange(currentPage + 1)}
          className="px-3 py-1 border rounded disabled:opacity-50"
          disabled={currentPage === totalPages}
        >
          Next
        </button>
      </div>
      {addUserModel && (
        <AddUser
          
          onClose={cancelAddUser}
          onSubmit={(formData) => confirmAddUser(formData)}
        />
      )}
      {editUserModel && (
        <EditUser
          user={itemToEdit}
          onClose={cancelEditUser}
          onEdit={(formData) => confirmEditUser(formData)}
        />
      )}
      {deleteModalShow && (
        <DeleteUser
          itemName={
            currentUsers.find((p) => p.id === itemToDelete)?.name || "Unknown User"
          }
          onClose={cancelDelete}
          onDelete={confirmDelete}
        />
      )}
      {viewUserModel && (
        <ViewUser
          user={currentUsers.find((p) => p.id === itemToView) || null}
          onClose={cancelView}
        />
      )}
    </div>
  );
};

export default UserDetails;


const formatDateTime = (value) => {
  if (!value) return "";
  const date = new Date(value);
  return isNaN(date.getTime()) ? "" : date.toLocaleString();
};
